module.exports = __webpack_public_path__ + "static/media/KobeIceRink.515105d5.png";